export const renderStatus = (status) => {
  let text = "";
  let color = "font_blue";

  switch (status) {
    case "paid":
      text = "Paid";
      break;

    case "unpaid":
      text = "Unpaid";
      break;

    case "void":
      text = "Void";
      break;

    case "adjusted":
      text = "Adjusted";
      break;

    case "released":
      text = "Released";
      break;

    case "partial paid":
      text = "Partial Paid";
      break;

    case "paid_and_carry_forward":
      text = "Paid And Carry Forward";
      break;

    case "not_collected":
      text = "Not Collected";
      break;

    case "collected":
      text = "Collected";
      break;

    case "partially_collected":
      text = "Partially Collected";
      break;

    case "settled":
      text = "Settled";
      break;

    case "partially_settled":
      text = "Partially Settled";
      break;
  }

  return { text, color };
};
